module.exports = __webpack_public_path__ + "img/border.dcb9e1c8.png";